import React from 'react'
import { Lottie } from 'lottie-react'
import animation from '@src/assets/lotties/loading_shield'

export const LoadingShield = () => {
    return (
        <Lottie src={animation} loop autoplay style={{ height: 400, width: 'auto', margin: '0 auto' }}/>
    )
}